// store/modules/chatbot/stateChatBot.js
const stateChatBot = {
  nameComponent: "Store chatbot state Global",

  // Preguntas del bot
  question: null,
  unsavedChanges: false,
  activeFechQuestion: false,
  refreshQuestions: false,

  // Lista GLOBAL de chats (para la pantalla de notificaciones generales)
  list: [],

  // Loading general
  loading: false,

  // 🔑 Caché por reserva: { 'reservation_123': [chats...] }
  reservationCache: {},

  // Respuesta actual
  answer: {},
};

export default stateChatBot;
